import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../../../services/shared';
import { CLAIMS_TAG_TYPES } from './tags';

/**
 * Single base RTK Query API for the Claims backend (one `createApi` per backend).
 *
 * Intentionally EMPTY of endpoints — features inject their own via `claimsApi.injectEndpoints` in
 * `features/{x}/data/{x}Endpoints.ts` (mirrors `modules/financialClearance/data/verificationsApi.ts`).
 * Never create a second `createApi` for this backend from within this module. Import this base api
 * by file path (`../../../data/claimsApi`) from feature endpoint files, not via the `data` barrel,
 * to avoid import cycles.
 */
export const claimsApi = createApi({
  reducerPath: 'claimsApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.claims),
  tagTypes: CLAIMS_TAG_TYPES,
  endpoints: () => ({}),
});
